import type { PermissionData } from '../types'

export function computeReversePermission(permissionData: PermissionData) {
  if (!permissionData.gotSomeValidRoutes) return 'disabledForInvalidRoute'

  return 'enabled'
}
